import { render, staticRenderFns } from "./StatisticsOfWebmasters.vue?vue&type=template&id=4e0e152a&scoped=true&"
import script from "./StatisticsOfWebmasters.vue?vue&type=script&lang=js&"
export * from "./StatisticsOfWebmasters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0e152a",
  null
  
)

export default component.exports